import { MappedProjectT } from '@/routes/settings/projects/lib/projectsTypes.ts'
import {
  OrderFilterT,
  SortByFilterT,
} from '@/routes/projectStages/issues/lib/hooks/useActiveFilters.ts'

export function sortProjects(arr: MappedProjectT[], sortBy?: SortByFilterT, order?: OrderFilterT) {
  let key: 'createdAtFull' | 'endDateFull' = 'createdAtFull'

  if (sortBy === 'DUE_DATE') {
    key = 'endDateFull'
  }

  // console.log(arr, sortBy, order)
  // console.log(arr[0][key])

  // else if (sortBy === 'UPDATED_AT') {
  //   key = 'updatedAt'
  // }

  const sorted = [...arr].sort((a, b) => {
    if (!a[key]) {
      // console.log(1)
      return 1
    }
    // Move items without due date to the end
    if (!b[key]) {
      // console.log(2)
      return -1
    } // Move items without due date to the end

    // console.log(arr[0][key])
    // console.log(new Date(b[key]!).getTime() )

    if (order === 'DESC') {
      // console.log(3)
      return new Date(b[key]!).getTime() - new Date(a[key]!).getTime()
    }
    /*If there is no order, or order is 'ASC', sort in ascending order*/
    // console.log(4)

    return new Date(a[key]!).getTime() - new Date(b[key]!).getTime()
  })
  // console.log(sorted, `sorted after sort`)
  return sorted
}
